import type { Logger } from "@expert/logging";
import type { KyInstance } from "ky";

export const fetchAddressSuggestions = async (client: KyInstance, logger: Logger, searchText: string) => {
    const childLogger = logger.child({ module: "addressSuggestions" });
    if (searchText.length < 6) return [];
    try {
        const sanitizedSearchText = encodeURIComponent(searchText);
        const addresses = await client.get(`v1/address-autocomplete?text=${sanitizedSearchText}`).json<string[]>();

        return Array.from(new Set(addresses));
    } catch (error: unknown) {
        childLogger.warn({ error }, "addressSuggestions failure");
        throw error;
    }
};
